module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAABCklEQVRIx2P4aa9GI8QwajT9jP5PNKg9N/fwi0vEqyfW6PUPDzPOcwAin90Vb398pJrRr79/sN6SrbomWnx5AJA8++YmdYwGujH+ULvmujj+JV7CS32VV0dGH2z5+OsLdYy22ZrDvtCFa5G7xPJAnsUeYssC6s/N//vvL0VGf/39verM7MC9NUBzGebZM893BJoLdP7U6+spdfWjLy+9d5dzLnQDGgcME6b5jkDn66xPyDjWe+X9fYqMXnP/YN6JSTEHW/z3VAFdDURzb23tubwi81jf9icnqZP4qs/OgRi99fFxiMi3Pz8oNfr33z/rHhza8+zsp19fmy8smnB1NZBBVOIbLZ6Gg9EADDXAn5MhpWwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/lb.png
// module id = 322
// module chunks = 0